
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"d":"M7.205 19.596l.652-5.45h6.233v1.92H9.864l-.242 2.116a2.93 2.93 0 01.689-.27c.288-.079.569-.118.842-.118 1.06 0 1.872.315 2.439.945.571.625.857 1.504.857 2.636a3.78 3.78 0 01-.462 1.86 3.13 3.13 0 01-1.281 1.275c-.552.298-1.204.447-1.956.447a4.397 4.397 0 01-1.882-.41c-.586-.278-1.045-.657-1.377-1.135A2.776 2.776 0 017 21.778h2.475c.024.39.149.701.373.93.225.23.52.345.886.345.83 0 1.246-.616 1.246-1.846 0-1.138-.508-1.707-1.524-1.707-.576 0-1.006.186-1.289.557l-1.963-.461zM23.15 20.453c0 1.44-.325 2.55-.974 3.332-.645.781-1.555 1.172-2.732 1.172-1.187 0-2.104-.393-2.754-1.18-.65-.785-.974-1.894-.974-3.324v-1.949c0-1.44.322-2.55.967-3.332.65-.781 1.565-1.172 2.746-1.172 1.182 0 2.098.393 2.747 1.18.65.785.974 1.896.974 3.332v1.94zm-2.468-2.264c0-.766-.1-1.337-.3-1.713-.2-.381-.518-.572-.953-.572-.424 0-.735.176-.93.528-.19.351-.293.883-.307 1.596v2.725c0 .796.1 1.38.3 1.75.2.367.517.55.952.55.42 0 .73-.178.93-.535.2-.361.303-.925.308-1.692V18.19zM31.837 20.453c0 1.44-.325 2.55-.975 3.332-.644.781-1.555 1.172-2.731 1.172-1.187 0-2.105-.393-2.754-1.18-.65-.785-.974-1.894-.974-3.324v-1.949c0-1.44.322-2.55.966-3.332.65-.781 1.565-1.172 2.747-1.172 1.181 0 2.097.393 2.746 1.18.65.785.975 1.896.975 3.332v1.94zm-2.469-2.264c0-.766-.1-1.337-.3-1.713-.2-.381-.518-.572-.952-.572-.425 0-.735.176-.93.528-.19.351-.293.883-.308 1.596v2.725c0 .796.1 1.38.3 1.75.2.367.518.55.953.55.42 0 .73-.178.93-.535.2-.361.302-.925.307-1.692V18.19z","fill":"#fff"}})])
          )
        }
      }
    